export default __webpack_public_path__ + "static/stamp-fede4cf9a3d14f67416503a0658626ed.png";